export function WrenchIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 640 640">
      <path
        fill="currentColor"
        d="M541.4 162.6c7.6-7.6 20.3-5.7 24.1 4.3 6.8 17.7 10.5 37 10.5 57.1 0 88.4-71.6 160-160 160-17.5 0-34.4-2.8-50.2-8L178.9 562.9c-28.1 28.1-73.7 28.1-101.8 0s-28.1-73.7 0-101.8L264 274.2c-5.2-15.8-8-32.6-8-50.2 0-88.4 71.6-160 160-160 20.1 0 39.4 3.7 57.1 10.5 10 3.8 11.8 16.5 4.3 24.1l-88.7 88.7c-3 3-4.7 7.1-4.7 11.3V240c0 8.8 7.2 16 16 16h41.4c4.2 0 8.3-1.7 11.3-4.7z"
      />
    </svg>
  );
}
